import { gql } from '@apollo/client/core';

import { http } from '@article/pixel';
import UserService from '@/services/UserService';
import LocationService from '@/services/LocationService';
import { executeQuery } from '@/components/commons/utils.js';

const PING_QUERY = gql`
  query session($zip: String, $customertoken: String) {
    session(zip: $zip, customertoken: $customertoken) {
      user {
        email
        sessionId
        verified
        isTrade
        expired
        registered
        cart {
          cartItems {
            quantity
          }
        }
      }
      office
      geoLocation {
        accuracyRadius
        countryId
        countryCode
        regionId
        regionCode
        city
        currencyId
        zipcode
      }
      zipLocation {
        accuracyRadius
        countryId
        countryCode
        regionId
        regionCode
        city
        currencyId
        zipcode
      }
      customerToken
    }
  }
`;

export default class SessionService {
  /**
   * Ping to update and retrieve user, location data
   * @param {String} zip
   */
  static async ping(zip) {
    const pingUrl = '/api/account/ping';
    const zipcode = zip || LocationService.getPreferredLocation().zipcode;

    const httpPromise = http.post(pingUrl, {
      zip: zipcode,
      __i: UserService.getSessionId(),
      __t: UserService.getCustomerToken()
    });

    const {
      user, //
      customerToken,
      office,
      geoLocation,
      zipLocation,
      common,
    } = await httpPromise;

    return {
      user, //
      customerToken,
      office,
      geoLocation,
      zipLocation,
      common,
    };
  }

  static async pinggql(zip, customerTokenString) {
    const zipcode = zip || LocationService.getPreferredLocation().zipcode;

    try {
      const result = await executeQuery(PING_QUERY, {
        zip: zipcode,
        customertoken: customerTokenString
      });

      const {
        user, //
        customerToken,
        office,
        geoLocation,
        zipLocation,
        common,
      } = result.session;

      return {
        user, //
        customerToken,
        office,
        geoLocation,
        zipLocation,
        common,
      };
    } catch (error) {
      console.error(error);
      return {
        error,
      };
    }
  }
}
